import type React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/Index";
import ResizableTextarea from "../../../components/common/ResizableTextArea";

interface IntroductionLetterSectionProps {
  value: string;
  onChange: (value: string) => void;
}

const IntroductionLetterSection: React.FC<IntroductionLetterSectionProps> = ({
  value,
  onChange,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const reduxTheme = useSelector((state: RootState) => state.theme);
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Introduction Letter
      </Typography>

      <ResizableTextarea
        label="Letter"
        value={value}
        onChange={onChange}
        colors={colors}
        reduxTheme={reduxTheme}
        placeholder="Enter your introduction letter..."
      />
    </Box>
  );
};

export default IntroductionLetterSection;
